import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { combineLatest, Subscription } from 'rxjs'
import { CmsFacetService } from '../../../services/cms-search/cms-facet.service'
import { ActivatedRoute } from '@angular/router'
import { triggerSmoothCollapseAnimation } from '../../../../shared/animations/smooth-collapse.animation'
import { Facet, FacetCount } from 'smartsearch.js'
import { map } from 'rxjs/operators'
import { MbConstants } from '../../../../shared/mb-constants'
import { CmsFacet } from '../../types'

@Component({
  selector: 'mb-cms-facet-list',
  templateUrl: './cms-facet-list.component.html',
  styleUrls: ['./cms-facet-list.component.scss'],
  animations: [triggerSmoothCollapseAnimation],
})
export class CmsFacetListComponent implements OnInit, OnDestroy {

  @Input() jobs?: boolean

  subscription = new Subscription()
  currentFilter = ''

  facets$ = combineLatest([this.cmsFacetService.facets$, this.cmsFacetService.readonlyFacets$]).pipe(
    map(([facets, readonlyFacets]) => this.mergeFacets(facets, readonlyFacets)))

  constructor (private cmsFacetService: CmsFacetService,
               private route: ActivatedRoute) {
  }

  ngOnInit (): void {
    this.subscription.add(this.route.queryParamMap.subscribe(params => {
      const query = params.get('query') ?? ''
      const queryContent = params.get(MbConstants.QUERY_CONTENT_PARAM) ?? ''
      this.currentFilter = `${query}${queryContent ? '&' + queryContent : ''}`
    }))
  }

  mergeFacets (facets: Facet[], readonlyFacets: CmsFacet[]): Facet[] {
    if (readonlyFacets.length) {
      facets = facets.map(facet => {
        const counts: FacetCount[] = []
        const roFacet = readonlyFacets.find(readonlyFacet => readonlyFacet.category === facet.config.baseName
          || readonlyFacet.category.replaceAll(' ', '_') === facet.config.baseName)
        if (roFacet) {
          const roCount = facet.counts.find(count => count.value === roFacet.name)
          counts.push({
            count: roCount?.count ?? 0,
            value: roCount?.value ?? roFacet.name,
            filterQuery: `facet.filter.${roFacet.category.replaceAll(' ', '_')}`,
            urlFilterQuery: `facet.filter.${roFacet.category.replaceAll(' ', '_')}=${this.cmsFacetService.escapeFacetName(roFacet.name)}`
          })
          return {
            ...facet,
            counts
          } as Facet
        }
        return facet
      })
    }
    return facets
  }

  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }
}

